import React, { useEffect, useRef, useState, Fragment } from "react";
import { customer, customerEdit, getBrancheslist } from '../utils/api';
import { Link,useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from "react-router-dom";
import axios from "axios";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Dropdown } from 'primereact/dropdown';
import "primereact/resources/themes/mdc-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import Select1 from 'react-select';
import {
    InputLabel,
   Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from '@mui/material';


const EnrollOrderLayer = () => {

  const [selectedOptions, setSelectedOptions] = useState([]);

    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [nameErr, setNameErr] = useState(false);
    const [phoneErr, setPhoneErr] = useState(false);
    const [staffErr, setStaffErr] = useState(false);
    const [staffList, setStaffList] = useState([]);
    const [customerType, setCustomerType] = useState("New");
    const [customerList, setCustomerList] = useState([]);
    const [customerID, setCustomerID] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [showServiceForm, setShowServiceForm] = useState(false);
    const [staffID, setStaffID] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [serviceID, setServiceID] = useState([]);
    const [customerkeyarr, setCustomerArr] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [showCustomerOrder, setShowCustomerOrder] = useState(false);
    const [customerOrders, setCustomerOrders] = useState([]);
    const [settingsList, setSettingsList] = useState([]);
         
   const [formData, setFormData] = useState({
      name: '',
      phone:'',
      email: '',
       });
    const navigate = useNavigate();
  
  /*  let { id } = useParams();
  
console.log('id', id);

    async function fetchCustomerInfo() {
      axios
        .get(process.env.REACT_APP_API_BASE_URL+"customer-details/" + id)
        .then((res) => {
           if (res.data) {
            console.log("red data", res.data);
             
            setFormData({ ...formData, name: res.data.name, phone: res.data.phone, email: "", password: "1234", branch_name: "1" });
                     
          } else {
            toast.success("something went wrong...");
          }
        })
        .catch((err) => {
          console.error(err);
          alert(err);
        });
    }

    useEffect(() => {
      if(id){ 
       fetchCustomerInfo();
        } else{
         setFormData({ ...formData, name: "", phone: "", email: "", password: "1234", branch_name: "1" });
         
        }
     }, [id]);

*/
    useEffect(() => {

        axios
        .get(process.env.REACT_APP_API_BASE_URL + "staff-all")
        .then((response) => {
            setStaffList(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
        
        axios.get(process.env.REACT_APP_API_BASE_URL+"customer-all")
        .then(response => {

let customeroptions=[];
let customeroptionarr=[];
let usersr=response.data.data;
usersr.map(function(arr, index){
    customeroptions.push({value:arr.id,label:arr.name+"("+arr.phone+")"});
    customeroptionarr[arr.id]=arr;
});

            setCustomerList(customeroptions);
             setCustomerArr(customeroptionarr);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
        axios.get(process.env.REACT_APP_API_BASE_URL+"service-list")
        .then(response => {

let servlist=[];
 response.data.data.map(function(arr, index){
  servlist[arr.id]=arr;
});


            setServiceList(servlist);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, []);
    
 

    const handleSubmit = async (e) => {
      e.preventDefault();
      setFormData({ ...formData, name: name, phone: phone, email: "", password: "1234", branch_name: "1" });
       
      try {
         if(name != "" && phone != ""){
                   
                    await  customer(formData);
                    toast.success('Customer details successfully saved');
                    setShowServiceForm(true);
                 } else{
                  if(!name){
                    setNameErr(true);
                   }
                 if(!phone){
                  setPhoneErr(true);
                    }
                }
      } catch (error) {
        toast.error('Something went wrong: ' + error.message);
      }
    };


const submitOrder =async()=> {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();
   let dt=""+dd;
   let mont=""+mm;
    if (dd < 10) dt = '0' + dd;
    if (mm < 10) mont = '0' + mm;
  
    const formattedToday = mont + '-' + dt + '-' + yyyy;
    var currenthour = today.toLocaleString([], { hour: '2-digit', minute: '2-digit' });
 
 
    let forminitialData={
        branch: 1,
        serviceID: serviceID.join(','),
        serviceDate: formattedToday,
        requestTime : currenthour,
        name: name,
        email: email,
        phone: phone,
        paymentType: "MANUAL",
        staff_id: staffID,
        customerID: customerID
      };
      setIsLoading(true);

      await  axios.post(process.env.REACT_APP_API_BASE_URL+"order-create", { ...forminitialData })
        .then((res) => {
            console.log(res.data);
           if(res.data.status==true){
            toast.success('Your order received sucessfully!!');
            setCustomerOrders(res.data.customerOrders);
            setShowCustomerOrder(true);
            setCustomerID(res.data.customerOrders[0].user_id);
 
          /*  setTimeout(function(){
              navigate('/'+JSON.parse(localStorage.getItem('activeUser')).user_type+'/orders');
          }, 1000);
           */
      
          }else{
            toast.error("something went wrong...")
          }
          setIsLoading(false);
     
        })
        .catch(err => {

          if (err.message.includes('phone')) {
            toast.error("Phone no already exist");
          }  else {
            // Handle other errors
            console.error('An error occurred:', err);
          }

          setIsLoading(false);
         
        setShowServiceForm(false);
        toast.error('Something went wrong: ' + err);
  
    });

    axios
    .get(process.env.REACT_APP_API_BASE_URL + "/setting-list")
    .then((response) => {
      const settingdata = response.data.data;
      let settingarray = [];

      settingdata.map((srvc, index) => (settingarray[srvc.setting_key] = srvc.setting_value));
      setSettingsList(settingarray);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    }); 

}


const fetchCustomerOrders = async (customerid) => {


  axios
  .get(process.env.REACT_APP_API_BASE_URL+"order-all/customer/"+customerid)
  .then((response) => {
   // setOrderList(response.data.data);
  })
  .catch((error) => {
    console.error("Error fetching data:", error);
  });



}




const FilterableDropdown = () => {
 /* const [selectedOption, setSelectedOption] = useState(null);
  
  const options = [
    { value: 'apple', label: 'Apple' },
    { value: 'banana', label: 'Banana' },
    { value: 'orange', label: 'Orange' },
    { value: 'grape', label: 'Grape' },
    { value: 'pear', label: 'Pear' },
  ];*/
  
  return (
    <div style={{ width: '300px', margin: '20px' }}>
      <Select1
         isSearchable
        options={customerList}
        value={customerList.filter(function(option) {
            return option.value === selectedOption;
          })}
        onChange={(e) =>{
           console.log("fiter:",e);
           setSelectedOption(e.value);
            setCustomerID(e.value); 
            if(e.value != ""){
                setName(customerkeyarr[e.value].name);
                setPhone(customerkeyarr[e.value].phone);
                setEmail(customerkeyarr[e.value].email);
            }else{
                setName("");
                setPhone("");
                setEmail("");
            }
         }}
        placeholder="Search and select..."
        noOptionsMessage={() => "No options found"}
        styles={{
          control: (base) => ({
            ...base,
            height: '50px',
            minHeight: '50px'
          }),
          menu: (base) => ({
            ...base,
            maxHeight: '200px'
          })
        }}
      />
    </div>
  );
};

const handleChange = (event) => {
  const { value } = event.target;
  setServiceID(typeof value === 'string' ? value.split(',') : value);
};

let arraykeys={
  "1": "Discount_on_1st_Booking",
  "6": "Discount_on_6th_Booking",
  "12" : "Discount_on_12th_Booking"
}
let indexarr = [1,6,12];

  return (
    <div className='row gy-4'>
      <div className='col-lg-12'>
        <div className='card mt-24'>
          <div className='card-header border-bottom'>
            <h6 className='text-xl mb-0'>Enroll Order</h6>
          </div>
          <div className='card-body p-24'>
            <ToastContainer></ToastContainer>
            {!showServiceForm  && !showCustomerOrder && (<>
            <FormControl>
            <FormLabel className="mb-2"  id="demo-row-radio-buttons-group-label ">Customer</FormLabel>
            <RadioGroup
                row
                defaultValue="New"
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="customertype"
            >
                <FormControlLabel onChange={()=>{
                setCustomerType("New");
                setName("");     
                setEmail("");     
                setPhone(""); 
                setCustomerID(""); 
                    
                }}  value="New" control={<Radio />} label="New Customer" />
                <FormControlLabel  onChange={()=>{
                    setCustomerType("Existing"); 
                    setName("");     
                    setEmail("");     
                    setPhone("");
                    setCustomerID(""); 
                   
                }} value="Existing" control={<Radio />} label="Existing Customer" />
                </RadioGroup>
            </FormControl>

{customerType == "New" &&  (<div id="">
            <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>
              <div className="row">
             
              
                  <div className='col-lg-6'>
                    <label
                      className='form-label fw-bold text-neutral-900'
                      htmlFor='title'
                    >
                       Name:{" "}
                    </label>
                    <input
                      type='text'
                      className={nameErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                      id='name'
                      name='name'
                      placeholder='Enter Name'
                      value={name}
                      onChange={(e) =>{
                        setName(e.target.value);
                        setNameErr(false);
                        if(e.target.value.trim() == ""){
                          setEmail("");
                          setNameErr(true);
                        }else{
                            setEmail("");//e.target.value.trim()+"@yopmail.com");
                        }
                     }}                    />
                        {nameErr && (
                        <span className="error-message">
                            {'Name is mandatory'}
                        </span>
                    )} 
                  </div>

                  <div className='col-lg-6'>
                    <label
                      className='form-label fw-bold text-neutral-900'
                      htmlFor='title'
                    >
                      Phone:{" "}
                    </label>
                    <input
                      type='text'
                      className={phoneErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                      id='phone'
                      placeholder='Enter Phone'
                      name="phone"
                      value={phone}
                      onChange={(e) =>{
                        setPhone(e.target.value.trim());
                        setPhoneErr(false);
                        if(e.target.value.trim() == ""){
                          setPhoneErr(true);
                        }
                     }}                    />
                       {phoneErr && (
                        <span className="error-message">
                            {'Phone No is mandatory'}
                        </span>
                    )} 
                  </div>
               
                   
                  <div className='col-lg-12 pt-3'>
                  {name!="" && phone!="" && <button type='button' disabled={isLoading?true:false} className='btn btn-primary-600 mt-3 radius-8 float-right'
                   onClick={()=>{
                    setShowServiceForm(true)
                  }}>
                  {isLoading ? "Loading...":"Continue"}
              </button>}
              </div>
              </div>
             
            </form>
          </div>)}
  
{customerType == "Existing" &&  (<div id="">
    <div className="row">
              <div  className='col-lg-6'>
                <label className='form-label fw-bold text-neutral-900'
                htmlFor="staff_id">
                  Choose Customer:{" "}
                </label>
                 
                {/*<Fragment>
                    <select size={"5"}
                 onChange={(e) =>{
                      setCustomerID(e.target.value); 
                      if(e.target.value != ""){
                        const selectedcustomer =  customerList.filter(item => {
                            return item.id.toString() === e.target.value;
                          });
                          console.log("selectedcustomer", selectedcustomer);
                          setName(selectedcustomer[0].name);
                          setPhone(selectedcustomer[0].phone);
                          setEmail(selectedcustomer[0].email);
                    }else{
                        setName("");
                        setPhone("");
                        setEmail("");
                    }
                   }} 
                   isClearable
                   isSearchable
                 id="customer_id"   name="customer_id"    value={customerID}   className='form-control border border-neutral-200 radius-8'
                >
                <option value={""}> Select Customer </option>
                {/*customerList.length >0 && customerList.map((customer, key)=>(<option value={customer.id}>{customer.name}</option>))* /}
                </select></Fragment>*/}
<FilterableDropdown />
 
              </div>
              {customerID !="" && (<div className='col-lg-12  pt-3'>
                  <button type='button' disabled={isLoading?true:false} onClick={()=>{
                    setShowServiceForm(true)
                  }} className='btn btn-primary-600 mt-3 radius-8 float-right'>
                  {isLoading ? "Loading...":"Continue"}
              </button>
              </div>)}


              </div>
    
    </div>)}     
       </>)}
    {showServiceForm && !showCustomerOrder && (<div id="">
    <div className="row">
              <div  className='col-lg-6'>
                <label className='form-label fw-bold text-neutral-900'
                htmlFor="staff_id">
                  Choose Service Type:{" "}
                </label>
                {/*<select
                 
                 onChange={(event) =>{
                  const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value);
                  setServiceID(selectedValues);
                     // setServiceID(e.target.value); 
                   }} 
                 id="service_id"   name="service_id"    value={serviceID}   className='form-control border border-neutral-200 radius-8'
                >
                <option value={""}> Select Service </option>
                {serviceList.length >0 && serviceList.map((service, key)=>(<option value={service.id}>{service.title}</option>))}
                </select>*/}



                <Select
        labelId="multiple-select-label"
        multiple
        className="form-control"
        value={serviceID}
        onChange={handleChange}
        renderValue={(selected) => {
         let listsrc="";
          selected.map((srv) => listsrc+=serviceList[srv].title+", ");

         // selected=  listsrc.join(', ')
       return listsrc;
        
           }}
      >
        {serviceList.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox checked={serviceID.indexOf(option.id) > -1} />
            <ListItemText primary={option.title} />
          </MenuItem>
        ))}
      </Select>



              </div>

              <div  className='col-lg-6'>
                <label className='form-label fw-bold text-neutral-900'
                htmlFor="staff_id">
                  Choose Staff:{" "}
                </label>
                <select
                 onChange={(e) =>{
                      setStaffID(e.target.value); 
                   }} 
                 id="staff_id"   name="staff_id"    value={staffID}   className='form-control border border-neutral-200 radius-8'
                >
                <option value={""}> Select Staff </option>
                {staffList.length >0 && staffList.map((staff, key)=>(<option value={staff.id}>{staff.name +"("+staff.phone+")"}</option>))}
                </select> 
 

              </div>
              <div className='col-lg-12 pt-3'>
              <button type='button'   onClick={()=>{
                    setShowServiceForm(false);
                  }} className='btn btn-primary-600 mt-3 radius-8 float-left'>
               Back
              </button>

              {serviceID !="" && staffID && (
                  <button type='button' disabled={isLoading?true:false} onClick={()=>{
                    submitOrder()
                  }} className='btn btn-primary-600 mt-3 radius-8 float-right'>
                {isLoading ? "Loading...":"Submit"}
              </button>
             )}  </div>

              
              </div>
    
    </div>)}
{showCustomerOrder && (<div>
  
  <h5 className="card-title  " style={{fontWeight: "600",
    lineHeight: "60px",
    marginBottom: "0",
    fontSize: "26px !important"}}> Customer Orderwise Discount</h5>

<div className="row">

{customerOrders.map((post, i) =>{ 
let styleactive={};
   if(customerOrders.length <= 12 || (customerOrders.length >12 && i>=12)){
      if(customerOrders.length == i+1){
          styleactive={
          backgroundColor:" #d31d53",
          color: "#fff"
        }    
      }
      return (
          <div className="col-md-2 col-6" key={"i"+i} >
              <div className="bx-890" style={styleactive}>
                 <h4 style={styleactive}>  {(indexarr.includes(i%12+1)) ? settingsList[arraykeys[i%12+1]]+" OFF":""}  </h4>
             </div>
            </div>
            )
    }
   })}

</div>
<div className="row">
<div className="col-md-12 col-12 text-right"  >
           <Link  to={'/'+JSON.parse(localStorage.getItem('activeUser')).user_type+`/customer-view/${customerID}`}
                                                          className="btn btn-success mr-3 float-left"
                                                      >
                                                         Customer View Page
                                                    </Link>
           <Link  to={'/'+JSON.parse(localStorage.getItem('activeUser')).user_type+`/orders`}
                                                          className="btn btn-primary mr-3 float-right"
                                                      >
                                                         Customer Orders
                                                    </Link> 
</div>
</div>
  </div>)}
          </div>
        </div>
      </div>
      {/* Sidebar Start */}
    </div>
  );
};

export default EnrollOrderLayer;
